import { logErrorToConsole } from '../../constants';

const getPreferredCabinByFlightSegmentIndex = (preferredCabins, index) => {
  try {
    if (!Array.isArray(preferredCabins)) throw Error('invalid preferredCabins passed.');
    if (typeof index !== 'number' || index < 0 || index >= preferredCabins.length) throw Error('Invalid index passed to getPreferredCabinByFlightSegmentIndex.');
    const preferredCabin = preferredCabins[index] || undefined; // undefined is intentional.
    return preferredCabin || (preferredCabins.every((x) => x === undefined) || (preferredCabins.every((x) => x === '')) ? undefined : '');
  } catch (error) {
    logErrorToConsole('[ERROR] occured in getPreferredCabinByFlightSegmentIndex: ', error);
    return undefined;
  }
};

export default getPreferredCabinByFlightSegmentIndex;
